import React, {useEffect, useRef, useState} from "react";
import {MyS3} from "./context";
import {Slide} from "@mui/material";
import DrawTwoToneIcon from "@mui/icons-material/DrawTwoTone";
import {
  Face6TwoTone,
  FastForwardTwoTone,
  KeyboardArrowLeftTwoTone,
  KeyboardArrowRightTwoTone,
  PauseCircleTwoTone,
  PlayCircleTwoTone,
  ShareTwoTone,
  SkipNextTwoTone,
  SkipPreviousTwoTone
} from "@mui/icons-material";
import * as PropTypes from "prop-types";
import {Helmet} from "react-helmet";

function FastRewindTwoTone(props) {
  return null;
}

FastRewindTwoTone.propTypes = {onClick: PropTypes.func};

function FastRewindTwoToneIcon(props) {
  return null;
}

FastRewindTwoToneIcon.propTypes = {onClick: PropTypes.func};
const Player = ({p, su, foo, done, startDraw}) => {
  const containerRef = useRef(null);
  const [speed, setSpeed] = useState(12);
  const [doneb, setDoneb] = useState(false);
  const [art, setArt] = useState(false);
  const [open, setOpen] = useState(false);
  const DrawLoc = ()=>{
    setArt(1)
    startDraw()
  }
  const ar = () =>
    (<g>
      <path d="M133,616.5c5.6-20.9,23-32.6,34-48.8c11.8-17.4,24.7-33.8,37.2-50.5c11.9-16,24.4-31.5,36.2-47.7
			c12.3-16.9,24.3-34,35.9-51.5c10.9-16.4,25.3-30.7,32.2-51c-4.6-5.2-9.5-10.1-14.7-14.6c-38.9-29.8-73.2-64.8-108.2-98.6
			c-27.5-26.4-56.8-50.9-87.6-73.4c-4.7-13.2,1-24.8,9.9-34.6c8.8-9.5,18.4-18.2,28.7-26.1c10.8-8.4,23-6.2,33.9-0.3
			c17.6,9.4,34.5,19.9,51.7,30c1.7,1,3.2,2.4,4.9,3.5c60.9,33.9,110.6,81.3,158.2,131.3c13.7,14.5,28.1,28.3,41.8,42.8
			c14.9,16,16.3,24,5.9,42.5c-12.8,22.5-26.8,44.3-40.4,66.4c-8.8,14.5-17.9,28.7-26.5,43.3c-27.5,46.6-63.5,86.7-97.2,128.6
			c-12.4,15.5-26.7,29.5-42.5,41.6c-13.9,10.7-26.1,11.1-41.1,1.5C168.9,640.3,152.4,629.3,133,616.5z M403.8,348.9
			c-58-78.6-184-18.2-250.4-203.8c-8,6.4-16.7,12.8-20.3,25.5c8.5,7,16.9,13.9,25,21.1c23.2,20.4,47.3,39.9,69.1,61.7
			c32.2,32.6,66.3,63.4,102,92c6.1,4.8,11.5,10.5,18.4,17c-5.9,12.4-9.9,25-17,35.4c-21.8,32.1-44.3,63.8-67.5,94.9
			c-26.2,35.2-53.5,69.4-80.1,104.2c-2.1,3.2-4.1,6.6-5.7,10.2c6.2,11.1,16,15,25.7,17.9c23.6-15.5,66.2-61.9,99.8-108
			C351.2,450.5,396.5,375.1,403.8,348.9L403.8,348.9z"/>

    </g>)

  useEffect(() => {
    setInterval(() => {
      (done() && !doneb) && setDoneb(true)
    }, 1000);
  }, []);

  const man = (u) => {
    setSpeed(u);
    foo(u);

  }

  const mn = () => {
    p();

    //console.log(p.current);
  setDoneb(false);
  }
  return (



      <div ref={containerRef} className="w-auto mt--4 h-8 relative overflow-hidden d-flex justify-content-end">

        <Helmet>
          <title>{su && su.name}</title>
          <meta name="description" content={su && su.description}/>

          <meta property="og:title" content={su && su.name}/>
          <meta property="og:type" content="website"/>
          <meta property="og:image" content={su && su.thumb}/>
          <meta property="og:description"
                content={su && su.description}/>

          <meta property="og:video" content={su && su.video}/>
        </Helmet>

        {!open && (<div className="rounded menu"><KeyboardArrowLeftTwoTone
          className="bg-gray-400 rounded mr---1" onClick={() => setOpen(true)}/></div>)}
          <Slide container={containerRef.current} direction="left" in={open} mountOnEnter unmountOnExit
        >
          <div className="flex">
            {open  && (
                <div className="rounded menu"><KeyboardArrowRightTwoTone className="bg-gray-400 rounded mr---1"
                                                                               onClick={() => setOpen(false)}/></div>)
            }
              <div className="mx-1 bg-white rounded menu flex ">
               <div> <ShareTwoTone onClick={() => MyS3().shareV(su())}/></div>
                <div>   <Face6TwoTone
                                      onClick={() => DrawLoc()}/></div>
              <div>  <DrawTwoToneIcon color={art==1 ? 'warning' : 'disabled'}
              onClick={() => DrawLoc()}/>
              </div>

          </div>
          <div className="mx-1 bg-white rounded menu">
            <SkipPreviousTwoTone onClick={() => DrawLoc()}/>

            <FastForwardTwoTone style={{transform: 'rotate(180deg)'}} onClick={() => man(speed + 6)}/>
            {(speed == 0 || doneb) ? (
             <> <PlayCircleTwoTone onClick={() => !doneb ? man(12) : mn()}/></>
            ) : (

              <PauseCircleTwoTone onClick={() => man(0)}/>

            )}

            <FastForwardTwoTone onClick={() => man(speed + 6)}/>

            <SkipNextTwoTone onClick={() => DrawLoc()}/>
          </div>
          </div>


          </Slide>
      </div>





  )

}
export default Player;
